module.exports = __webpack_public_path__ + "img/仓储-货物标签.c1e61cf3.jpg";